import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { Observable, throwError } from "rxjs";
import { catchError, timeout } from "rxjs/operators";
import { DisplayloadingService } from "../services/displayloading.service";


@Injectable()
export class TimeoutInterceptor implements HttpInterceptor{
  constructor(private ls:DisplayloadingService, private popc:PopoverController){

  }


  intercept(req: HttpRequest<any>,next: HttpHandler): Observable<HttpEvent<any>> {
    //Nur für bestimmte Requests unterbrechen
    //if(req.url.indexOf("get_humidor_contents")!==-1){
    return next.handle(req).pipe(timeout(10000)).pipe(
      catchError((error) => {
        if (error instanceof HttpErrorResponse) {
          if(typeof(error.status)!=="undefined"){
            switch(error.status){
              case 0:
                this.ls.presentMessage("request-error.0",4000,"error");
              break;
              case 408:
                this.ls.presentMessage("request-error.408",4000,"error");
              break;
            }
          }
        }
        else{
          if(error.name==="TimeoutError"){
            this.ls.presentMessage("request-error.408",4000,"error");
          }
        }
        let loadingBanner:HTMLElement|null=document.querySelector("app-humidor-popover-loading");
        if(loadingBanner!==null){
          this.popc.dismiss();
        }
        return throwError(error);
      }));
    /*}
    else{
      return next.handle(req);
    }*/
  }
}
